"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Img = void 0;
/**
 * Shows an image based version of the logo
 */
const React = require("react");
const react_transition_group_1 = require("react-transition-group");
const cssTransitions_1 = require("../../../../helpers/cssTransitions");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles);
class Img extends React.Component {
    constructor() {
        super(...arguments);
        this.state = { isLoaded: false };
    }
    componentDidMount() {
        this.setImageSource();
    }
    componentDidUpdate(prevProps) {
        if (this.props.src !== prevProps.src) {
            this.setState({
                isLoaded: false
            });
            this.setImageSource();
        }
    }
    setImageSource() {
        const img = new Image();
        img.onload = () => this.setState({
            isLoaded: true
        });
        img.src = this.props.src;
    }
    render() {
        const { isLoaded } = this.state;
        const { className, style, src, responsive = false, fullwidth = false } = this.props;
        return (React.createElement(react_transition_group_1.CSSTransition, { classNames: cssTransitions_1.assetTransition, timeout: 500, in: isLoaded, mountOnEnter: true },
            React.createElement("img", { src: src, style: style, className: [
                    css("image", {
                        "-responsive": responsive,
                        "-fullwidth": fullwidth
                    }),
                    className
                ].join(" "), "data-test": "image" })));
    }
}
exports.Img = Img;
//# sourceMappingURL=index.js.map